import CandidateRecordContainer from "../../../Components/Candidates";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const CandidateRecord = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Candidate Management";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "recruiter"]}
      />

      {/* Main content */}
      <CandidateRecordContainer />
    </>
  );
};

export default CandidateRecord;
